import { render } from "./BulkPolicyEdit.vue?vue&type=template&id=1f00e7d7&ts=true"
import script from "./BulkPolicyEdit.vue?vue&type=script&lang=ts"
export * from "./BulkPolicyEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__